import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;
const axios = createClient({ baseUrl, isAdminSite: true });

export const getPrivacyPolicy = (data) =>
  axios.get("/privacypolicy", data ? { params: data } : {});

export const updatePrivacyPolicy = (data) =>
  axios.post("/privacypolicyupdate", data);
